module.exports = __webpack_public_path__ + "5f5fb9e275a8e6dd0f3e8d2d7b0855f1.png";